__turbopack_context__.v({
  "className": "exo_d02791d1-module__GwC_9W__className",
  "variable": "exo_d02791d1-module__GwC_9W__variable",
});
